import { PopupDialog } from "molecule/popupDialog/PopupDialog";
import styled from "@emotion/styled";
import { PopupDialogHeading } from "molecule/popupDialog/PopupDialogHeading";
import { APP_BREAKPOINT } from "src/constants/layout";
import { SimpleButton } from "atom/button/SimpleButton";

const DeleteDialog = styled(PopupDialog)`
  --popup-dialog-width: 680px;
  --popup-dialog-close-bg: transparent;
  --icon-color: var(--color-charcoal);
  background-color: var(--color-cream, #fffcf3);
  border-radius: var(--border-radius, 8px);

  @media screen and (max-width: ${APP_BREAKPOINT}px) {
    --popup-dialog-width: 343px;
  }
`;

const DeleteWrapper = styled.div`
  padding: 24px 24px 32px 24px;
`;

const DeleteHeading = styled(PopupDialogHeading)`
  color: var(--color-charcoal, #212121);
  margin-bottom: 16px;
`;

const DeleteText = styled.div`
  color: var(--color-charcoal, #212121);
  margin-bottom: 24px;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
  letter-spacing: -0.32px;
`;

const DeleteAction = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: end;
  align-items: center;
  gap: 24px;
`;

const DeleteDeleteButton = styled(SimpleButton)`
  background-color: #d04734;
  color: var(--color-white, #ffffff);
  padding: 15px 28px;
  border-radius: 120px;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 100% */
  letter-spacing: -0.32px;
  text-transform: capitalize;

  transition: box-shadow 0.2s ease;

  &:hover {
    transition: box-shadow 0.2s ease;
    box-shadow:
      0px 0px 0px 0px rgba(0, 0, 0, 0.2),
      -3px 3px 9px 0px rgba(0, 0, 0, 0.2),
      -13px 11px 17px 0px rgba(0, 0, 0, 0.17),
      -28px 24px 22px 0px rgba(0, 0, 0, 0.1),
      -50px 43px 26px 0px rgba(0, 0, 0, 0.03),
      -79px 67px 29px 0px rgba(0, 0, 0, 0);
  }
`;

export const deleteLabByCodeStyled = {
  DeleteDialog,
  DeleteWrapper,
  DeleteHeading,
  DeleteText,
  DeleteAction,
  DeleteDeleteButton
};
